import { render, staticRenderFns } from "./ActivityTab.vue?vue&type=template&id=6f19a520"
import script from "./ActivityTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports